function EmployeeExitDetails() {
    return (
        <div>
            <h1>EmployeeExitDetails</h1>
        </div>
    )
}

export default EmployeeExitDetails;